// 页内锚点平滑滚动工具
import type { MouseEvent } from "react";

export const scrollToId = (id: string) => {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

export const makeAnchor =
  (id: string) =>
  (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    scrollToId(id);
  };